import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { Toggle } from "@onshopfront/components";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import Button from "../../../Common/Buttons/Button";
import { setOption } from "../../../Utilities/Platform/Options/Options";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    id: string;
    name: string;
    file: string;
    dispatch: ThunkDispatch<any, any, any>;
}

interface State {
    remember: boolean;
}

export class ApplicationDownload extends React.Component<Props, State> {
    public state = {
        remember: false,
    };

    protected handleRememberChange = (e: React.FormEvent<HTMLInputElement>): void => {
        this.setState({
            remember: e.currentTarget.checked,
        });
    };

    protected handleCancel = (): void => {
        if(this.state.remember) {
            setOption(`client_${this.props.id}_download`, false);
        }

        this.props.dispatch(hideDialog());
    };

    protected handleDownload = (): void => {
        if(this.state.remember) {
            setOption(`client_${this.props.id}_download`, true);
        }

        window.open(this.props.file, "_blank");

        this.props.dispatch(hideDialog());
    };

    public render(): React.ReactNode {
        return (
            <div className="application-download">
                <p>
                    An application ({this.props.name}) is attempting to download a file,
                    would you like to download it?
                </p>
                <label className="flex items-center gap-2">
                    <Toggle
                        onChange={this.handleRememberChange}
                        checked={this.state.remember}
                    />
                    Remember my choice
                </label>
                <div className="buttons">
                    <Button
                        classes={[ "button-cancel" ]}
                        onClick={this.handleCancel}
                    >
                        Ignore
                    </Button>
                    <Button
                        classes={[ "button-primary" ]}
                        onClick={this.handleDownload}
                    >
                        Download
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(ApplicationDownload);
